import React from 'react';
import { UFBLogo } from '@udemy/react-brand-components';
import { CustomCategoriesModel, LearningPathsMenuModel } from '../ufb-browse-types';
import { BrowseSection } from './mobile-nav/browse-section.react-component';
import { ManageAndTeachSection } from './mobile-nav/manage-and-teach-section.react-component';
import { SubNavs } from './mobile-nav/sub-navs.react-component';
export function createUFBContext(udData, i18n) {
  return {
    get browseSection() {
      return /*#__PURE__*/React.createElement(BrowseSection, null);
    },
    get manageAndTeachSection() {
      return /*#__PURE__*/React.createElement(ManageAndTeachSection, null);
    },
    get subNavs() {
      return /*#__PURE__*/React.createElement(SubNavs, null);
    },
    get badgeContext() {
      const context = {
        unseenCredits: 0
      };
      if (!udData.Config.features.notifications) {
        context.unreadActivityNotifications = 0;
      }
      if (!udData.Config.brand.is_messaging_enabled) {
        context.unreadMessages = 0;
      }
      if (!udData.Config.features.shopping_cart) {
        context.cartBuyables = 0;
      }
      return context;
    },
    get logo() {
      return /*#__PURE__*/React.createElement(UFBLogo, null);
    },
    createStores(headerStore) {
      return {
        learningPathsMenuModel: new LearningPathsMenuModel(headerStore, i18n),
        customCategoriesModel: new CustomCategoriesModel(headerStore, i18n, udData)
      };
    },
    urls() {
      const orgId = udData.Config.brand.organization.id;
      return {
        ASSESSMENTS: '/skills-assessment/',
        BROWSE: '/organization/home/',
        LABS: '/labs/listing/',
        LEARNING_PATHS: '/learning-paths/',
        MY_LEARNING_PATHS: '/learning-paths/my/',
        PRO_PATHS: '/learning-paths/pro/',
        SEARCH: '/organization/search/',
        SEARCH_SUGGESTIONS: `/organizations/${orgId}/search-suggestions/`
      };
    }
  };
}
//# sourceMappingURL=create-ufb-context.js.map